import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import showNotification from "../../../helpers/show_notification";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import exportFromJSON from "export-from-json";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import TagsInput from "react-tagsinput";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../helpers/forms_helper";
// actions

const UpdateEquipments = (props) => {
  const { SearchBar } = Search;
  const refContainer = useRef(null);
  const refNewCategoryForm = useRef(null);

  useEffect(() => {
    loadAllCategories();
    loadAllUnits();
    loadAllEquipments();
  }, []);

  const [allEquipments, setAllEquipments] = useState([]);
  const [allEquipmentsFiltered, setAllEquipmentFiltered] = useState([]);
  const loadAllEquipments = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipments/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllEquipments(response.data);
      setAllEquipmentFiltered(response.data);
      setSelectedCategoryFilter("");
      setSelectedSubCategoryFilter("");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipmentcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allUnits, setAllUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState();
  const loadAllUnits = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipmentunits/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllUnits(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [newUnitModal, setNewUnitModal] = useState();
  const [newSubUnits, setNewSubUnits] = useState([]);
  const handleAddNewUnit = async (e, v) => {
    const object = {
      unit: v.name,
    };
    let url = process.env.REACT_APP_BASEURL + "equipmentsunit/insert";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      loadAllUnits();
      setSelectedUnit(v.name);
      setNewUnitModal(!newUnitModal);
    } else {
      showNotification(response.message, "Error");
    }
  };


  const [newCategoryModal, setNewCategoryModal] = useState();
  const [newSubCategories, setNewSubCategories] = useState([]);
  const handleAddNewCategory = async (e, v) => {
    try {
      const object = {
        category: v.name,
        sub_category: newSubCategories,
      };
      let url = process.env.REACT_APP_BASEURL + "equipmentcategories/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        setSelectedCategory(v.name);
        setAllSubCategories(newSubCategories);
        setNewSubCategories([]);
        setNewCategoryModal(!newCategoryModal);
        refNewCategoryForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const [newSubCategoryModal, setNewSubCategoryModal] = useState();
  const handleAddNewSubCategory = async (e, v) => {
    try {
      const object = {
        category: selectedCategory,
        sub_category: v.name,
      };
      let url =
        process.env.REACT_APP_BASEURL + "equipmentcategories/insert_subcategory";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        let all_sub_cat = [...allSubCategories];
        all_sub_cat.push(v.name);
        setAllSubCategories(all_sub_cat);
        setSelectedSubCategory(v.name);
        setNewSubCategoryModal(!newSubCategoryModal);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const handleEquipmentStatusUpdate = async (row) => {
    let url = process.env.REACT_APP_BASEURL + "equipments/activate_deactivate";

    const response = await postSubmitForm(url, {
      id: row._id,
      is_active: !row.is_active,
    });

    if (response && response.status === 1) {
      loadAllEquipments();
    } else {
      showNotification(response.message, props.t("Error"));
    }
  };

  function showStatusFormatter(cell, row) {
    // if (row.is_active) {
    return (
      <>
        <div className="custom-control custom-switch mb-2" dir="ltr">
          <input
            type="checkbox"
            title="Click to change status."
            className="custom-control-input"
            id={"customSwitch1" + row._id}
            checked={row.is_active}
          />
          <label
            title="Click to change status."
            className="custom-control-label"
            htmlFor={"customSwitch1" + row._id}
            style={{ "font-weight": "100", cursor: "pointer" }}
            onClick={() => {
              handleEquipmentStatusUpdate(row);
            }}
          ></label>
        </div>

        {row.is_active ? (
          <span class="font-size-12 badge-soft-success badge badge-success badge-pill">
            {props.t("Active")}
          </span>
        ) : (
          <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
            {props.t("Inactive")}
          </span>
        )}
      </>
    );
  }

  const [editEquipmentModal, setEditEquipmentModal] = useState();
  const [selectedEquipment, setSelectedEquipment] = useState();
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        const rowNumber = (+pageNumber - 1) * +pageSize + (+rowIndex + 1);
        return rowNumber;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
          text: props.t("Name"),
          dataField: "name",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "15%" };
          },
        },
      
        {
          dataField: "category",
          text: props.t("Category"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
          dataField: "sub_category",
          text: props.t("Sub-Category"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
            dataField: "brand",
            text: props.t("Brand"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
          {
            dataField: "unit",
            text: props.t("Unit"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
          {
            dataField: "cost_price",
            text: props.t("Cost Price"),
            sort: true,
            formatter:(cel,row)=>{
                return (row.cost_price+"/"+row.unit)
              },
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
        
        {
          dataField: "threshold",
          text: props.t("Threshold"),
          sort: true,
          formatter:(cel,row)=>{
            return (row.threshold+" "+row.unit)
          },
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        
    {
      text: props.t("Status"),
      formatter: showStatusFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row, rowIndex, extraData) => {
        return (
          <span className="text-info">
            <i
              className="bx bxs-edit font-size-15"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let categories = [...extraData[0]];
                let arr = categories.filter(
                  (category) => category.category === row.category
                );
                if (arr.length > 0) {
                  setAllSubCategories(arr[0].sub_category);
                }
                setSelectedCategory(row.category);
                setSelectedSubCategory(row.sub_category);
                setSelectedUnit(row.unit);
                setEditEquipmentModal(!editEquipmentModal);
                setSelectedEquipment(row);
              }}
            ></i>
          </span>
        );
      },
      formatExtraData: [allCategories, allUnits],
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );




  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const pagination_options = {
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 50,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: allEquipments && allEquipments.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const handleValidUpdate = async (e, v) => {
    try {
    // console.log(v);
    // return
      v.id = selectedEquipment._id;
      let url = process.env.REACT_APP_BASEURL + "equipments/update";
      let response = await postSubmitForm(url, v);
      if (response.status === 1) {
        setEditEquipmentModal(!editEquipmentModal);
        showNotification(response.message, "Success");
        refContainer.current.reset();
        loadAllEquipments();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState();
  const [allSubCategoriesFilter, setAllSubCategoriesFilter] = useState([]);
  const [selectedSubCategoryFilter, setSelectedSubCategoryFilter] = useState();
  useEffect(() => {
    if (selectedCategoryFilter) {
      let arr = JSON.parse(JSON.stringify(allEquipments));
      if (selectedSubCategoryFilter) {
        let new_arr = arr.filter(
          (item) =>
            item.category === selectedCategoryFilter &&
            item.sub_category === selectedSubCategoryFilter
        );
        setAllEquipmentFiltered(new_arr);
      } else {
        let new_arr = arr.filter(
          (prod) => prod.category === selectedCategoryFilter
        );
        setAllEquipmentFiltered(new_arr);
      }
    } else {
      setAllEquipmentFiltered(allEquipments);
    }
  }, [selectedCategoryFilter, selectedSubCategoryFilter]);

  const handleDownload = async () => {
    const fileName = "all_equipments";
    const exportType = "xls";

    let data_to_export = allEquipmentsFiltered;

    if (data_to_export) {
      var data = [];
     data_to_export.forEach(function (v) {
        data.push({
          name: v.name,
          category: v.category,
          sub_category: v.sub_category,
          brand: v.brand,
          unit: v.unit,
          remarks: v.remarks,
          threshold: v.threshold ,
          cost_price: v.cost_price,
          available: v.available_in_unit,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Equipments")}
            breadcrumbItem={props.t("All Equipments")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>

                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <CardTitle>{props.t("All Equipments")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View/Update all existing equipments here")}
                  </CardSubtitle>
                  <ToolkitProvider
                    keyField="_id"
                    data={allEquipmentsFiltered && allEquipmentsFiltered}
                    columns={columns}
                    search
                  >
                    {(propst) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...propst.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>

                            <Col lg={8} className="text-right">
                              <Row>
                                <Col lg={6}>
                                  <AvField
                                    name="category_filter"
                                    type="select"
                                    value={selectedCategoryFilter}
                                    onChange={(e) => {
                                      setSelectedCategoryFilter(e.target.value);
                                      setSelectedSubCategoryFilter("");
                                      if (e.target.value) {
                                        var categories = JSON.parse(
                                          JSON.stringify(allCategories)
                                        );
                                        let arr = categories.filter(
                                          (category) =>
                                            category.category === e.target.value
                                        );
                                        setAllSubCategoriesFilter(
                                          arr[0].sub_category
                                        );
                                      } else {
                                        setAllSubCategoriesFilter([]);
                                      }
                                    }}
                                  >
                                    <option value="">
                                      {props.t("All Categories")}
                                    </option>
                                    {allCategories &&
                                      allCategories.map((category) => {
                                        return (
                                          <option value={category.category}>
                                            {category.category}
                                          </option>
                                        );
                                      })}
                                  </AvField>
                                </Col>
                                <Col lg={6}>
                                  <AvField
                                    name="sub_category_filter"
                                    type="select"
                                    errorMessage={props.t(
                                      "Category cannot be empty"
                                    )}
                                    onChange={(e) =>
                                      setSelectedSubCategoryFilter(
                                        e.target.value
                                      )
                                    }
                                    value={selectedSubCategoryFilter}
                                  >
                                    <option value="">
                                      {props.t("All Sub-Categories")}
                                    </option>
                                    {allSubCategoriesFilter &&
                                      allSubCategoriesFilter.map(
                                        (sub_category) => {
                                          return (
                                            <option value={sub_category}>
                                              {sub_category}
                                            </option>
                                          );
                                        }
                                      )}
                                  </AvField>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          condensed
                        />
                      </div>
                    )}
                  </ToolkitProvider>

            {/* Edit Equipment Modal  */}
                  <Modal
                    size="lg"
                    isOpen={editEquipmentModal}
                    toggle={() => setEditEquipmentModal(!editEquipmentModal)}
                  >
                    <ModalHeader
                      toggle={() => setEditEquipmentModal(!editEquipmentModal)}
                    >
                      {props.t("Update Item")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={handleValidUpdate}
                                ref={refContainer}
                              >
                                <Row>
                                  <Col lg={6}>
                                    <Row>
                                      <Col lg={12}>
                                        <AvField
                                          name="name"
                                          label={props.t("Name")}
                                          value={
                                            selectedEquipment && selectedEquipment.name
                                          }
                                          placeholder={props.t(
                                            "Enter Item Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: { value: true },
                                          }}
                                          errorMessage={props.t(
                                            "Name cannot be empty"
                                          )}
                                        />
                                      </Col>
                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={8}>
                                            <AvField
                                              name="category"
                                              label={props.t("Category")}
                                              type="select"
                                              value={selectedCategory}
                                              validate={{
                                                required: { value: true },
                                              }}
                                              errorMessage={props.t(
                                                "Category cannot be empty"
                                              )}
                                              onChange={(e) => {
                                                setSelectedCategory(
                                                  e.target.value
                                                );
                                                if (e.target.value) {
                                                  var categories = JSON.parse(
                                                    JSON.stringify(
                                                      allCategories
                                                    )
                                                  );

                                                  let arr = categories.filter(
                                                    (category) =>
                                                      category.category ===
                                                      e.target.value
                                                  );
                                                  setAllSubCategories(
                                                    arr[0].sub_category
                                                  );
                                                } else {
                                                  setAllSubCategories([]);
                                                }
                                              }}
                                            >
                                              <option value="">
                                                {props.t("--Select Category--")}
                                              </option>
                                              {allCategories &&
                                                allCategories.map(
                                                  (category) => {
                                                    return (
                                                      <option
                                                        value={
                                                          category.category
                                                        }
                                                      >
                                                        {category.category}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </AvField>
                                          </Col>
                                          <Col lg={4}>
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Link
                                              class="btn btn-success waves-effect waves-light btn-sm"
                                              onClick={() => {
                                                setNewCategoryModal(
                                                  !newCategoryModal
                                                );
                                              }}
                                            >
                                              <i class="mdi mdi-file-plus"></i>{" "}
                                              {props.t("Add New")}
                                            </Link>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={8}>
                                            <AvField
                                              name="sub_category"
                                              label={props.t("Sub-Category")}
                                              type="select"
                                              required
                                              errorMessage={props.t(
                                                "Sub-Category cannot be empty"
                                              )}
                                              value={selectedSubCategory}
                                              onChange={(e) => {
                                                setSelectedSubCategory(
                                                  e.target.value
                                                );
                                              }}
                                            >
                                              <option value="">
                                                {props.t(
                                                  "--Select Sub-Category--"
                                                )}
                                              </option>
                                              {allSubCategories &&
                                                allSubCategories.map(
                                                  (subcategory) => {
                                                    return (
                                                      <option
                                                        value={subcategory}
                                                      >
                                                        {subcategory}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </AvField>
                                          </Col>
                                          <Col lg={4}>
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Link
                                              class="btn btn-success waves-effect waves-light btn-sm"
                                              onClick={() => {
                                                if (selectedCategory) {
                                                  setNewSubCategoryModal(
                                                    !newSubCategoryModal
                                                  );
                                                } else {
                                                  showNotification(
                                                    props.t(
                                                      "Select a category first!"
                                                    ),
                                                    props.t("Error")
                                                  );
                                                }
                                              }}
                                            >
                                              <i class="mdi mdi-file-plus"></i>{" "}
                                              {props.t("Add New")}
                                            </Link>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col lg={12}>
                                        <AvField
                                          name="threshold"
                                          value={
                                            selectedEquipment &&
                                            selectedEquipment.threshold.toString()
                                          }
                                          label={props.t("Threshold")}
                                          placeholder={props.t(
                                            "Enter Threshold Quantity for Centre"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Threshold cannot be empty."
                                              ),
                                            },
                                            pattern: {
                                              value: "^[0-9]+$",
                                              errorMessage: props.t(
                                                "Only numbers are allowed."
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>

                                    </Row>
                                  </Col>{" "}
                                  <Col lg={6}>
                                    <Row>
                                      <Col lg={12}>
                                      
                                            <AvField
                                              name="brand"
                                              label={props.t("Brand")}
                                              type="text"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              errorMessage={props.t(
                                                "Brand cannot be empty"
                                              )}
                                              value={
                                                selectedEquipment &&
                                                selectedEquipment.brand
                                              }
                                            >
                                          
                                            </AvField>
                                    
                                      </Col>

                                     
                                      <Col lg={12}>
                                        <AvField
                                          name="remarks"
                                          label={props.t("Remarks")}
                                          placeholder={props.t("Enter Remarks")}
                                          type="textarea"
                                          value={
                                            selectedEquipment && selectedEquipment.remarks
                                          }
                                        />
                                      </Col>
                                      <Col lg={12}>
                                        <AvField
                                          name="cost_price"
                                          label={props.t("Cost Price")}
                                          value={
                                            selectedEquipment &&
                                            selectedEquipment.cost_price
                                          }
                                          placeholder={props.t(
                                            "Enter cost price"
                                          )}
                                          type="number"
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Submit")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {/* <Button type="submit">Submit</Button> */}
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>


            {/* New Unit Modal  */}
                  <Modal
                    size="md"
                    isOpen={newUnitModal}
                    toggle={() => setNewUnitModal(!newUnitModal)}
                  >
                    <ModalHeader toggle={() => setNewUnitModal(!newUnitModal)}>
                      {props.t("Add new unit")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewUnit(e, v);
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Name of Unit") + " *"}
                                      placeholder={props.t("Enter Unit Name")}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty."
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>{props.t("Sub-Unit")}</Label> (
                                    {props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubUnits}
                                      onChange={(tags) => {
                                        setNewSubUnits(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
       
            {/* New Category Modal  */}
                  <Modal
                    size="md"
                    isOpen={newCategoryModal}
                    toggle={() => setNewCategoryModal(!newCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewCategoryModal(!newCategoryModal)}
                    >
                      {props.t("Add new category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Category")}
                                      placeholder={props.t(
                                        "Enter Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>
                                      {props.t("Sub-Category Name")}
                                    </Label>{" "}
                                    ({props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubCategories}
                                      onChange={(tags) => {
                                        setNewSubCategories(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

            {/* New Sub Category modal  */}
                  <Modal
                    size="md"
                    isOpen={newSubCategoryModal}
                    toggle={() => setNewSubCategoryModal(!newSubCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() =>
                        setNewSubCategoryModal(!newSubCategoryModal)
                      }
                    >
                      {props.t("Add new sub-category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewSubCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Sub-Category")}
                                      placeholder={props.t(
                                        "Enter Sub-Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>


                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(UpdateEquipments)));
